<div
  class="object-card-container {{ className }}"
  [class.selected]="selected"
  (click)="handleClick()"
  [class.select-mode]="selectMode"
>
  <div class="card-content">
    <div class="card-header">
      <div class="title" (click)="toggleSelect(); $event.stopPropagation()">
        <span class="object-icon">
          @if (objectConfig.icon) {
            <fa-icon [icon]="objectConfig.icon" [size]="'lg'"></fa-icon>
          }
        </span>
        @if (selectable && object.can_edit) {
          <div class="check" (click)="$event.stopPropagation()">
            <sui-checkbox
              [checked]="selected"
              (checkedChange)="toggleSelect()"
            ></sui-checkbox>
          </div>
        }
        <span [innerHTML]="objectConfig.title | highlight: filterString"></span>
      </div>
      <div class="cart-tools">
        @if (object.shared_with?.length > 0) {
          <div class="type tool">
            <fa-icon
              [icon]="['fas', 'share']"
              [suiTooltip]="sharedWithTooltip"
            ></fa-icon>
          </div>
        }
        @if (object.owner && object.owner?.avatar_url) {
          <div class="user tool" [suiTooltip]="object.owner.name">
            <img
              [src]="object.owner.avatar_url"
              [appFallbackImage]="avatarFallback"
              class="avatar"
              loading="lazy"
            />
          </div>
        }
        @if (canEdit) {
          <!--
          <div class="cog tool" (click)="onObjectEdit($event);">
            <fa-icon [icon]="['fas', 'cog']"></fa-icon>
          </div>
          -->
          @if (hasMenu) {
            <div class="menu tool" (click)="showDropdown($event)">
              <a><fa-icon [icon]="['fas', 'bars']"></fa-icon></a>
              <div #cardDropdownContainer></div>
            </div>
          }
        }
      </div>
    </div>
    <div class="card-body">
      <div class="body-image">
        <div
          class="card-image"
          [style.background-image]="
            isVisible && object.thumbnail
              ? 'url(' + object.thumbnail + ')'
              : null
          "
          [class.has-image]="!!object.thumbnail"
        >
          @if (!object.thumbnail) {
            <span class="object-icon content">
              @if (
                objectConfig.icon &&
                object.object_class_id != NomObjectClass.CONNECTOR
              ) {
                <fa-icon [icon]="objectConfig.icon" [size]="'5x'"></fa-icon>
              }
              @if (
                objectConfig.image &&
                object.object_class_id === NomObjectClass.CONNECTOR
              ) {
                <img [src]="objectConfig.image" alt="" loading="lazy" />
              }
            </span>
          }
        </div>
      </div>

      <div class="body-content">
        <div class="title">
          <span
            [suiTooltip]="
              object?.title.length > titleCharLimit
                ? $safeNavigationMigration(object?.title)
                : ''
            "
            [innerHTML]="
              truncateString(
                $safeNavigationMigration(object?.title),
                titleCharLimit
              ) | highlight: filterString
            "
          ></span>
        </div>
        @if (object.workspace && object.workspace?.title) {
          <div class="workspace-info">
            <fa-icon
              [icon]="['fas', 'folder']"
              class="workspace-icon"
            ></fa-icon>
            <span class="workspace-title">{{ object.workspace?.title }}</span>
          </div>
        }
        <p
          [suiTooltip]="
            object.description.length > descriptionCharLimit
              ? object.description
              : ''
          "
          [innerHTML]="objectDescription | highlight: filterString"
          class="description"
        ></p>

        @if (timeCreatedVisible) {
          <div class="date-time-item">
            <span class="date-time-label"
              >{{ "object-card.label.created" | translate }}:</span
            >
            <span class="date-time-value">{{
              object.time_created | date: "yyyy-MM-dd HH:mm"
            }}</span>
          </div>
        }
        @if (timeModifiedVisible) {
          <div class="date-time-item">
            <span class="date-time-label"
              >{{ "object-card.label.updated" | translate }}:</span
            >
            <span class="date-time-value">{{
              object.time_modified | date: "yyyy-MM-dd HH:mm"
            }}</span>
          </div>
        }
      </div>
    </div>

    <div class="card-footer">
      @if (statsVisible && object.stats) {
        <div class="stats">
          @if (object.stats.feeds?.total) {
            <span [suiTooltip]="'object-card.stats.feeds' | translate">
              {{ object.stats.feeds.total }}
              <fa-icon [icon]="['fas', 'rss']"></fa-icon>
            </span>
          }
          @if (object.stats.social?.twitter?.active) {
            <span [suiTooltip]="'object-card.stats.twitter' | translate">
              {{ object.stats.social.twitter.active }}
              <fa-icon [icon]="['fab', 'twitter']"></fa-icon>
            </span>
          }
          @if (object.stats.social?.facebook) {
            <span [suiTooltip]="'object-card.stats.facebook' | translate">
              {{ object.stats.social.facebook }}
              <fa-icon [icon]="['fab', 'facebook']"></fa-icon>
            </span>
          }
          @if (object.stats.dimensions?.total) {
            <span [suiTooltip]="'object-card.stats.dimensions' | translate">
              {{ object.stats.dimensions.total }}
              <fa-icon [icon]="['fas', 'cube']"></fa-icon>
            </span>
          }
          @if (object.stats.dashboards?.total) {
            <span [suiTooltip]="'object-card.stats.dashboards' | translate">
              {{ object.stats.dashboards.total }}
              <fa-icon [icon]="['fas', 'th-large']"></fa-icon>
            </span>
          }
        </div>
      }
      <div class="card-badge"></div>
    </div>
  </div>
</div>
